export default "__VITE_ASSET__BZiv6DLC__"